import { Box, Button } from '@chakra-ui/react';
import React, { useCallback, useEffect, useState } from 'react';
import ConversationArea from '../../classes/ConversationArea';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import usePlayersInTown from '../../hooks/usePlayersInTown';

interface Props {
  conversation: ConversationArea;
  newMedia: string | undefined;
}

/**
 * If a vote form has been submitted by a player in the same conversation area, make the voting box visible.
 * Once the current player has voted, their Player obect is updated with their vote.
 * 
 * @param param0 
 * @returns 
 */
export default function CalledVote({ conversation, newMedia }: Props): JSX.Element {
  const { myPlayerID, socket } = useCoveyAppState();
  const curPlayer = usePlayersInTown().find(p => myPlayerID === p.id);

  const [vote, setVote] = useState<string>("");


  const voted = useCallback(() => {
    if (curPlayer) {
      const convoWithMedia = conversation.copy();
      convoWithMedia.proposedMedia = newMedia;
      if (socket) socket.emit('playerVote', curPlayer.toServerPlayer(), convoWithMedia.toServerConversationArea());
    }
  }, [curPlayer, conversation, newMedia, socket]);

  const handleYes = () => {
    setVote("Yes");
    if (curPlayer) { curPlayer.vote = true; }
    voted();
  }

  const handleNo = () => {
    setVote("No");
    if (curPlayer) { curPlayer.vote = false; }
    voted();
  }

  useEffect(() => {
    setVote("");
  }, [newMedia]);

  if (vote) {
    return (<Box><h1>You have voted: {vote}</h1></Box>);
  }
  return (
    <Box>
      <h1>A vote has started!</h1>
      <h2>Do you want to add &apos;{newMedia}&apos; to the queue?</h2>
      <Button onClick={handleYes} color="primary" value="Yes">Yes</Button>
      <Button onClick={handleNo} color="primary" value="No">No</Button>
    </Box>
  );
}